import {Menu as _Menu} from 'antd'
import openWindow from '@/script/openWindow.mjs'

const MenuItem = ({children, title, to, onClick, ...props}) => {
    if (children) {
        const menuItems = children
            .filter(a => a)
            .map(({key, ...props}) => (
                <MenuItem
                    key={key ?? props.title}
                    {...props}
                />
            ))

        if (0 < menuItems.length) {
            return (
                <_Menu.SubMenu
                    title={title}
                    {...props}
                >
                    {menuItems}
                </_Menu.SubMenu>
            )
        }
        else {
            return null
        }
    }
    else {
        const _onClick = (() => {
            if (onClick) {
                return onClick
            }
            else if (to) {
                const [path, params] = to

                return e => {
                    const target = e.domEvent.altKey ? '_self' : '_blank'
                    openWindow(path, params, target)
                }
            }
            else {
                return null
            }
        })()

        return (
            <_Menu.Item
                onClick={_onClick}
                {...props}
            >
                {title}
            </_Menu.Item>
        )
    }
}

export default function Menu({items, ...props}) {
    const menuItems = items
        .filter(a => a)
        .map(({key, ...props}) => (
            <MenuItem
                key={key ?? props.title}
                {...props}
            />
        ))

    return (
        <_Menu
            mode="horizontal"
            selectable={false}
            theme="dark"
            subMenuCloseDelay={0.3}
            {...props}
        >
            {menuItems}
        </_Menu>
    )
}
